module.exports = __webpack_public_path__ + "img/EU_Phoenix Program_logo_crvFN-01.49b6629b.png";